import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import kutil, { registerProgressStore, registerAuthStore, registerSettingsStore, registerTabsStore } from "@modules/kutil";
import commonCode from "@modules/common_code";
import config from "@modules/config";
import workRoute from "@modules/work_route";

import { useProgressStore } from "@components/progress/progress_store";
import { useAuthStore } from "@user/store/auth_store";

import "@user/assets/css/common.scss";

import App from "@user/App";

// store
registerProgressStore(() => useProgressStore.getState());
registerAuthStore(() => useAuthStore.getState());

async function init() {
  try {
    if (config.get("auth.useApigee") == "true") {
      while(true) {
        const ret = await kutil.getRefreshToken();
        if (ret) {
          break;
        }
        await kutil.sleep(3000);
      }
    }
    while(true) {
      const ret = await useAuthStore.getState().init();
      if (ret) {
        break;
      }
      await kutil.sleep(3000);
    }
    while(true) {
      const ret = await commonCode.initCommonCodes();;
      if (ret) {
        break;
      }
      await kutil.sleep(3000);
    }
    while(true) {
      await workRoute.initWorkRoutes();
      if (workRoute.isInitialized) {
        break;
      }

      await kutil.sleep(3000);
    }
  } finally {
  }
}

await init();

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
